import { useState, useEffect } from 'react';
// import FormField from '../components/FormField';

// const PRICE_PER_PERSON = 15;
// const MAX_TICKETS = 5;

const input = {
  background: 'none',
  border: '1px solid #444',
  color: 'white',
  padding: '10px 14px',
  fontSize: '0.9rem',
  width: '100%',
  outline: 'none',
  boxSizing: 'border-box',
  fontFamily: 'inherit',
};

export default function SpaceshipControl() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/.netlify/functions/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'Spaceship Control' }),
      });
      if (!res.ok) throw new Error('Server error');
      setSubmitted(true);
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // — CHECKOUT FORM (commented out) —
  // const [form, setForm] = useState({
  //   name: '', email: '', phone: '', quantity: '1', requirements: '',
  // });
  // const [errors, setErrors] = useState({});
  // const [loading, setLoading] = useState(false);
  // const [serverError, setServerError] = useState('');
  //
  // const qty = parseInt(form.quantity, 10);
  // const total = qty * PRICE_PER_PERSON;
  //
  // const validate = () => {
  //   const e = {};
  //   if (!form.name.trim()) e.name = 'Required';
  //   if (!form.email.trim()) e.email = 'Required';
  //   else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Invalid email';
  //   return e;
  // };
  //
  // const handleChange = ({ target: { name, value } }) => {
  //   setForm(prev => ({ ...prev, [name]: value }));
  //   if (errors[name]) setErrors(prev => ({ ...prev, [name]: undefined }));
  // };
  //
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const errs = validate();
  //   if (Object.keys(errs).length) { setErrors(errs); return; }
  //   setLoading(true);
  //   setServerError('');
  //   try {
  //     const res = await fetch('/.netlify/functions/create-checkout-session', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ product: 'event-presale', formData: form }),
  //     });
  //     const data = await res.json();
  //     if (!res.ok) throw new Error(data.error || 'Something went wrong');
  //     window.location.href = data.url;
  //   } catch (err) {
  //     setServerError(err.message);
  //     setLoading(false);
  //   }
  // };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, []);

  return (
    <div style={{
      color: 'white',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '60px 20px 80px',
      boxSizing: 'border-box',
      overflow: 'hidden',
    }}>

      <p style={{ fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.8, margin: '0 0 8px', textShadow: '0 2px 12px rgba(0,0,0,0.9)' }}>
        Arcade Antics
      </p>
      <h1 style={{ fontSize: '2rem', margin: '0 0 10px', textShadow: '0 2px 20px rgba(0,0,0,1), 0 0 40px rgba(0,0,0,0.8)' }}>Spaceship Control</h1>
      <p style={{ opacity: 0.75, margin: '0 0 48px', fontSize: '0.9rem', maxWidth: '380px', textAlign: 'center', lineHeight: 1.6, textShadow: '0 2px 12px rgba(0,0,0,0.9)' }}>
        {/* Interactive event — presale tickets. $15 per person. Select your group size below. */}
        Interactive event — coming soon.
      </p>

      <div style={{ border: '1px solid #2a2a2a', padding: '32px', width: '100%', maxWidth: '480px', background: '#000' }}>
        {submitted ? (
          <p style={{ textAlign: 'center', opacity: 0.7, margin: 0, lineHeight: 1.7 }}>
            You're on the list. We'll let you know when tickets are available.
          </p>
        ) : (
          <>
            <p style={{ fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.45, margin: '0 0 20px' }}>
              Notify me for the event announcement
            </p>
            <form onSubmit={handleSubscribe} noValidate>
              <input
                style={{ ...input, marginBottom: '12px' }}
                type="email"
                value={email}
                onChange={e => { setEmail(e.target.value); setError(''); }}
                placeholder="you@example.com"
              />
              {error && (
                <p style={{ color: '#e87c2b', fontSize: '0.85rem', margin: '0 0 12px' }}>{error}</p>
              )}
              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  background: loading ? 'none' : '#e87c2b',
                  border: '1px solid #e87c2b',
                  color: 'white',
                  padding: '14px 28px',
                  fontSize: '0.9rem',
                  letterSpacing: '0.08em',
                  cursor: loading ? 'default' : 'pointer',
                  marginTop: '4px',
                  opacity: loading ? 0.5 : 1,
                  transition: 'opacity 0.2s',
                  fontFamily: 'inherit',
                }}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </form>
          </>
        )}

        {/* — CHECKOUT FORM (commented out) —
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: '1px solid #2a2a2a',
          paddingBottom: '20px',
          marginBottom: '28px',
        }}>
          <span style={{ fontSize: '0.8rem', letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.45 }}>
            {qty} {qty === 1 ? 'ticket' : 'tickets'} × $15
          </span>
          <span style={{ fontSize: '1.4rem', letterSpacing: '0.02em', transition: 'all 0.15s' }}>
            ${total} <span style={{ fontSize: '0.75rem', opacity: 0.4 }}>CAD</span>
          </span>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <FormField label="Full Name *" error={errors.name}>
            <input style={input} name="name" value={form.name} onChange={handleChange} placeholder="Jane Smith" />
          </FormField>
          <FormField label="Email *" error={errors.email}>
            <input style={input} name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
          </FormField>
          <FormField label="Phone (optional)">
            <input style={input} name="phone" type="tel" value={form.phone} onChange={handleChange} placeholder="+1 (416) 555-0000" />
          </FormField>
          <FormField label="Number of Tickets *" error={errors.quantity}>
            <select
              style={{ ...input, cursor: 'pointer' }}
              name="quantity"
              value={form.quantity}
              onChange={handleChange}
            >
              {Array.from({ length: MAX_TICKETS }, (_, i) => i + 1).map(n => (
                <option key={n} value={n} style={{ background: '#111' }}>
                  {n} {n === 1 ? 'person' : 'people'} — ${n * PRICE_PER_PERSON} CAD
                </option>
              ))}
            </select>
          </FormField>
          <FormField label="Special Requirements / Accessibility Needs (optional)">
            <textarea
              style={{ ...input, resize: 'vertical', minHeight: '80px' }}
              name="requirements"
              value={form.requirements}
              onChange={handleChange}
              placeholder="Dietary restrictions, accessibility needs, etc."
            />
          </FormField>
          {serverError && (
            <p style={{ color: '#e87c2b', fontSize: '0.85rem', margin: '0 0 16px' }}>{serverError}</p>
          )}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: loading ? 'none' : '#e87c2b',
              border: '1px solid #e87c2b',
              color: 'white',
              padding: '14px 28px',
              fontSize: '0.9rem',
              letterSpacing: '0.08em',
              cursor: loading ? 'default' : 'pointer',
              marginTop: '8px',
              opacity: loading ? 0.5 : 1,
              transition: 'opacity 0.2s',
              fontFamily: 'inherit',
            }}
          >
            {loading ? 'Redirecting...' : `Proceed to Checkout — $${total}.00 CAD`}
          </button>
        </form>
        */}
      </div>
    </div>
  );
}
